// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_response_deleteRentalProperty(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["RentalPropertyDeleted"]);
}

var variablesConverter = {"deleteRentalPropertyInput":{},"__root":{"input":{"r":"deleteRentalPropertyInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

var wrapResponseConverter = {"__root":{"deleteRentalProperty":{"u":"response_deleteRentalProperty"}}};

var wrapResponseConverterMap = {
  response_deleteRentalProperty: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

var responseConverter = {"__root":{"deleteRentalProperty":{"u":"response_deleteRentalProperty"}}};

var responseConverterMap = {
  response_deleteRentalProperty: unwrap_response_deleteRentalProperty
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

var Utils = {};

var node = ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "landlordNodeId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MyClientsWidgetDeleteDialog_mutations_deleteRentalPropertyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "deleteRentalProperty",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/)
            ],
            "type": "RentalPropertyDeleted",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MyClientsWidgetDeleteDialog_mutations_deleteRentalPropertyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "deleteRentalProperty",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "landlordNodeId",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              }
            ],
            "type": "RentalPropertyDeleted",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "125dc968479945ce5c3b819d58f3f68c",
    "id": null,
    "metadata": {},
    "name": "MyClientsWidgetDeleteDialog_mutations_deleteRentalPropertyMutation",
    "operationKind": "mutation",
    "text": "mutation MyClientsWidgetDeleteDialog_mutations_deleteRentalPropertyMutation(\n  $input: DeleteRentalPropertyInput!\n) {\n  deleteRentalProperty(input: $input) {\n    __typename\n    ... on RentalPropertyDeleted {\n      landlordNodeId\n    }\n  }\n}\n"
  }
};
})());

var wrap_response_deleteRentalProperty = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_deleteRentalProperty = unwrap_response_deleteRentalProperty;
exports.wrap_response_deleteRentalProperty = wrap_response_deleteRentalProperty;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
